export default "__VITE_ASSET__BSZkS8QO__"